import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import {
    IResponseCreateProtocol,
    Protocol,
    ProtocolBuilder,
    IProtocolInfo,
    IProtocolItem,
} from '../interfaces/protocol.interfaces';
import { HttpNewService } from './application/http-new.service';

@Injectable({ providedIn: 'root' })
export class ProtocolService {
    public constructor(
        private http: HttpNewService, // private authService: AuthService
    ) {}

    public async getProtocol(
        formResultId: number,
        visitId: number,
    ): Promise<Protocol> {
        // const token = null;
        const data = {
            resultId: formResultId.toString(),
            visitId: visitId.toString(),
        };
        const params = new URLSearchParams(data);

        const items = await lastValueFrom<IProtocolItem[]>(
            this.http.get<Array<IProtocolItem>>('/protocol/template?' + params),
        );

        const protocol = ProtocolBuilder(items);

        return protocol;
    }

    public async saveProtocol(protocol: Protocol, visitID: number) {
        // const token = null;
        const fields = protocol.prepareToSave(visitID);
        // console.log(fields);
        return lastValueFrom<void>(
            this.http.post('/protocol/save', { fields }),
        );
    }

    /**
     * Создание протокола после подтвержения записи на приём к врачу
     */
    public createProtocol(
        visitId: number,
        formId: number,
    ): Observable<Array<IResponseCreateProtocol>> {
        // const token = null;
        const data = {
            pVisitId: visitId,
            pFormId: formId,
        };
        return this.http.post<Array<IResponseCreateProtocol>>(
            '/protocol/create',
            data,
        );
    }

    /**
     * Проверка на наличе возмжности просмотра и редактирования протокола пациентом
     */
    public async checkProtocol(formResultId: number, visitID: number) {
        // const token = null;
        const data = {
            pFormResultId: formResultId.toString(),
            pVisitId: visitID.toString(),
        };
        const params = new URLSearchParams(data);

        return lastValueFrom<Array<IProtocolInfo>>(
            this.http.get<Array<IProtocolInfo>>(`/protocol/check?${params}`),
        );
    }
}
